// ============================================================================
//  Sesiones de las áreas privadas (Customer Portal y panel de Afiliados)
// ----------------------------------------------------------------------------
//  Las dos zonas guardan su sesión en localStorage con claves distintas pero
//  el MISMO contrato (access/refresh + datos del usuario), porque ambas se
//  autentican contra el mismo endpoint de login del core.
//
//  Ojo: que exista una cadena en localStorage NO es estar autenticado. Esto
//  solo lee; quien decide dejar pasar es <RequireSession>, que además valida
//  el token contra el servidor.
// ============================================================================

export const SESSION_KINDS = {
   portal: {
      tokensKey: 'portal_tokens',
      userKey: 'portal_user',
      loginPath: '/customer-portal',
   },
   affiliate: {
      tokensKey: 'affiliate_tokens',
      userKey: 'affiliate_user',
      loginPath: '/affiliates',
   },
};

// localStorage puede traer JSON corrupto ("undefined", "null", truncado...).
export const safeParseObject = (raw) => {
   try {
      const parsed = JSON.parse(raw || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
   } catch (e) {
      return {};
   }
};

const config = (kind) => SESSION_KINDS[kind] || SESSION_KINDS.portal;

export const readAccessToken = (kind) => {
   const { tokensKey } = config(kind);
   const tokens = safeParseObject(localStorage.getItem(tokensKey));
   return typeof tokens.access === 'string' && tokens.access ? tokens.access : '';
};

export const readSessionUser = (kind) => {
   const { userKey } = config(kind);
   return safeParseObject(localStorage.getItem(userKey));
};

export const clearSession = (kind) => {
   const { tokensKey, userKey } = config(kind);
   try {
      localStorage.removeItem(tokensKey);
      localStorage.removeItem(userKey);
   } catch (e) {
      /* ignore */
   }
};

export const loginPathFor = (kind) => config(kind).loginPath;
